export default __webpack_public_path__ + "static/media/junk5.749a385b.svg";